/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Target_Match_ErrorInputs */



/**
* | output |
* | --- |
* | "Source and target event groups match. Nothing to copy." |
*
* @param {Source_Target_Match_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_target_match_error = /** @type {((inputs?: Source_Target_Match_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Target_Match_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les groupes source et cible sont identiques. Rien à copier.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quell- und Zielereignisgruppen stimmen überein. Es muss nichts kopiert werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I gruppi di eventi di origine e destinazione corrispondono. Niente da copiare.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исходная и целевая группы событий совпадают. Копировать нечего.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los grupos de eventos de origen y destino coinciden. No hay nada que copiar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源事件组和目标事件组匹配。无需复制任何内容。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースとターゲットのイベント グループが一致しています。コピーするものはありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत और लक्ष्य इवेंट समूह मेल खाते हैं। कॉपी करने के लिए कुछ भी नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os grupos de eventos de origem e destino correspondem. Nada a copiar.")
	return /** @type {LocalizedString} */ ("Source and target event groups match. Nothing to copy.")
});